import React from 'react';
import { RectangleSkeleton } from '@sm360/widget-commons-general';
import { LocaleService } from '@sm360/widget-commons-core-services';

const CashPaymentSkeleton = ({ isUsed, sellingPriceLabel }) => (
    <div className="cash-section tile-payment-info">
        <div className="payment-row price-row">
            <p className="payment-row-title sr-text is-bold">{sellingPriceLabel}</p>
            <div className="payment-row-section">
                {!isUsed && <p className="price-cash">{LocaleService.t('VEHICLE_TILE.CASH_BUY')}</p>}
                <p className="payment-row-price sr-text is-bold">
                    <RectangleSkeleton width={101} height={30} />
                </p>
            </div>
        </div>
    </div>
);

CashPaymentSkeleton.displayName = 'CashPaymentSkeleton';
export default CashPaymentSkeleton;
